import React from 'react';
import { SmButton, SmIcon } from '@smiles/smiles-react-design-system';

type TProps = React.HTMLProps<HTMLButtonElement> & {
  text: string;
  icon: {
    name: string;
    size: 'small' | 'medium' | 'large' | 'xlarge';
  };
  position: 'left' | 'right';
  isOutlined?: boolean;
  disabled?: boolean;
  ['data-testid']?: string;
};

export function ButtonWithIcon({
  text,
  position,
  icon,
  className,
  onClick,
  isOutlined,
  disabled,
  ...props
}: TProps) {
  return (
    <SmButton
      className={className}
      text={text}
      icon={<SmIcon name={icon.name} size={icon.size} />}
      positionIcon={position}
      onClick={onClick}
      isOutlined={isOutlined}
      data-testid={props['data-testid']}
      disabled={disabled}
    />
  );
}
